import styled from "styled-components";

/* Section wrapper */
export const Section = styled.section`
  padding: 20px 20px;
  background-color: #0a0a0a;
  text-align: center;
  border-top: 2px solid #0ff;
  border-bottom: 2px solid #0ff;
`;

/* Heading */
export const Heading = styled.h5`
  font-size: 1rem;
  color: #0ff;
  margin-bottom: 30px;
  font-weight: bold;
  letter-spacing: 2px;
`;

/* Gallery scroll container */
export const Gallery = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 20px;
  padding: 5px;
  scroll-behavior: smooth;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #0ff;
    border-radius: 10px;
    box-shadow: 0 0 5px #0ff;
  }
  &::-webkit-scrollbar-track {
    background: #111;
  }
`;

/* Individual Card */
export const Card = styled.div`
  background-color: #111;
  border: 2px solid #0ff;
  border-radius: 15px;
  padding: 10px;
  min-width: 200px;
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 0 25px #0ff, 0 0 50px #0ff;
  }

  @media (max-width: 480px) {
    min-width: 150px;
    padding: 15px;
  }
`;

export const Icon = styled.img`
  width: 35px;
  height: 35px;
  margin-bottom: 5px;
  object-fit: contain;
`;

export const CardTitle = styled.h5`
  font-size: 1rem;
  margin-bottom: 8px;
  color: #0ff;
`;

export const CardDesc = styled.p`
  font-size: 0.9rem;
  color: #aaa;
`;
